import React from 'react'
import { withRouter } from 'react-router-dom';

import moment from 'moment';

import { Section, Table, InfosBar, Text, Empty, ProfilePicture } from 'components';
import { Button, Container, Dimmer, Loader, Icon } from 'semantic-ui-react'

import { Typeof } from 'utils';

import { API } from 'services';

const EXAMENS_PER_PAGE = 10;

class PaneExamens extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      examens: [],
      examenCriteria: ''
    };

    this.handleExamenReload = this.handleExamenReload.bind(this);
    this.handleExamenSearch = this.handleExamenSearch.bind(this);
    this.handleExamenSelect = this.handleExamenSelect.bind(this);
  }

  componentDidMount() {
    this.handleExamenReload();
  }

  handleExamenSelect(examen) {
    //this.props.history.push(`/examens/${examen.uuid}`);
  }

  handleExamenSearch(criteria) {

    this.setState({
      examenCriteria: criteria
    });
  }

  handleExamenReload() {
    this.setState({
      loading: true
    }, () => {

      API.get(`clinics/${this.props.clinic.id}/examens`)
        .then((response) => {

          this.setState({
            examens: response.data,
            loading: false
          });

        })
        .catch(() => {

          this.setState({
            loading: false
          });

        })
    });
  }

  render() {

    const { examens } = this.state;

    let columns = [
        {
            id: 'uuid',
            header: 'UUID',
            value: (examen) => examen.uuid,
            render: (examen) => examen.uuid,
            fit: true
        },
      {
        id: 'type',
        header: 'Type',
        value: (examen) => examen.type,
        fit: true
      },
      {
        id: 'horse',
        header: 'Cheval',
        value: (examen) => examen.horse.name,
        fit: true
      },
      {
        id: 'date',
        header: "Date",
        value: (examen) => examen.date_create,
        render: (examen) => 
            Typeof.number(examen.date_create) ? <Text style={{"mono" : true}}>
              {moment(new Date(examen.date_create * 1000)).format('[Le] DD/MM/YYYY [à] HH:mm:ss')}
            </Text> : <Empty />
        ,
        fit: true
      },
      {
        id: 'conditions',
        header: "Conditions",
        value: (examen) => examen.conditions.length,
        render: (examen) => examen.conditions.length,
        fit: true
      },
    ];

    return (
      <React.Fragment>
        <Container>

          {/* Examens */}
          <Section title="Examens" onSearch={this.handleExamenSearch} actions={[
            <Button circular icon="sync" onClick={this.handleExamenReload} key={0} />
          ]}>

            {examens.length > 0 ? (

              <React.Fragment>

                {/* Number of available examens */}
                <InfosBar mode="column">
                  <span>{examens.length > 1 ? `${examens.length} examens disponibles` : '1 examen disponible'}</span>
                </InfosBar>

                {/* examens list */}
                <Table columns={columns}
                  criteria={this.state.examenCriteria}
                  items={examens}
                  itemsPerPage={EXAMENS_PER_PAGE}
                  onSelect={this.handleExamenSelect}
                  messageEmpty="Aucun examen ne correspond à votre recherche"
                />

              </React.Fragment>

            ) : (

              // No examen available
              <InfosBar mode="row">
                <span>Aucun cheval disponible</span>
              </InfosBar>

            )}

            <Dimmer active={this.state.loading} inverted>
              <Loader inverted>Chargement...</Loader>
            </Dimmer>

          </Section>

        </Container>

      </React.Fragment>
    );
  }
}

export default withRouter(PaneExamens);
